import React from "react";
import Dialogs from "./Dialogs";
import {connect} from "react-redux";
import {setActivePageSite} from "../../Redux/authReducer";
import {getMessage, sendMessage, setActiveUser} from "../../Redux/dialogsReducer";
import {compose} from "redux";
import withRedirect from "../../Utilits/Redirect";

class DialogsContainer extends React.Component {

    componentDidMount() {
        this.props.setActivePageSite("DIALOGS");
    }

    correspondence = (id, exitOnInterlocutors) => {
        this.props.history.push('/dialogs/' + id);
        this.props.getMessage(id);
        this.props.setActiveUser(id);
        if (window.innerWidth <= 500) {
            exitOnInterlocutors(true, false)
        }
    };

    render() {
        return(
            <Dialogs correspondence={this.correspondence} usersMessage={this.props.usersMessage}
                     sendMessage={this.props.sendMessage}
                     messages={this.props.messages}
                     activeUser={this.props.activeUser}
            />
        )
    }
}

let mapStateToProps = (state) => {
    return {
        usersMessage: state.dialogsPage.usersMessage,
        messages: state.dialogsPage.messages,
        activeUser: state.dialogsPage.activeUser,
        themeIsDark: state.appReducer.themeIsDark
    }
};

export default compose(
    connect(mapStateToProps, {setActivePageSite, getMessage, sendMessage, setActiveUser}),
    withRedirect
)(DialogsContainer)